import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';

/**
 * @Description this page String Library's Lowercase Action's configuration form
 * @Param       action - object 
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render 
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function Uppercase({ action, variables, setOpenVariable, variableRender, setField, disabled, outputVisible }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.STRING.';

    return (
        <div>
            <div className="form-element">
                {t(label + 'SOURCESTRING')}
                <TextInput action={action} inputName="sourceString" variables={variables}
                    setOpenVariable={setOpenVariable} isRequired displayName={t(label + "SOURCESTRING")}
                    fieldType="string" disabled={disabled} setField={setField} />
            </div>
            {
                !outputVisible &&
                <div className="form-element">
                    {t('CONTENT.CONFIGURATION-FORM.STRING.ASSIGN_TO_VARIABLE')}
                    <VariablePicker action={action} inputName="set" variables={variables}
                        setOpenVariable={setOpenVariable} variableRender={variableRender} isRequired disabled={disabled} />
                </div>
            }

        </div>
    )
}

